import { Link } from "react-router-dom";
import { featuredArticles, categoryMap } from "@/mocks/articles";

export default function HeroSection() {
  const mainArticle = featuredArticles[0];
  const sideArticles = featuredArticles.slice(1, 3);

  return (
    <section className="relative w-full min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20of%20floating%20newspaper%20clippings%20and%20digital%20media%20elements%20with%20warm%20amber%20deep%20crimson%20and%20gold%20tones%2C%20soft%20gradient%20dark%20background%2C%20editorial%20journalism%20aesthetic%2C%20clean%20modern%20design%20with%20organic%20flowing%20shapes%2C%20subtle%20texture%2C%20high%20detail%2C%20sophisticated%20atmosphere%2C%20dramatic%20lighting%2C%20artistic%20style&width=1600&height=900&seq=hero-bg-main-2026&orientation=landscape"
          alt="51黑料网 - 真实爆料第一平台"
          title="51黑料网 - 社会热点 娱乐八卦 科技资讯"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16">
        <div className="max-w-6xl mx-auto">
          {/* Main headline */}
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-flashlight-fill text-accent-400 text-xs"></i>
              </span>
              <span className="text-xs font-medium text-accent-300 tracking-wide">独家爆料 · 实时更新</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight">
              真实爆料
              <br />
              <span className="text-primary-400">第一平台</span>
            </h1>
            <p className="mt-4 md:mt-6 text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
              专注社会热点、娱乐八卦、科技资讯，为您提供真实及时的独家爆料内容
            </p>

            <Link
              to="/category/social"
              className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-white font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              查看最新爆料
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          {/* Featured cards - 3 overlapping cards */}
          <div className="relative max-w-5xl mx-auto h-[420px] md:h-[520px]">
            {featuredArticles.map((article, idx) => {
              const positions = [
                "absolute left-[5%] md:left-[8%] bottom-0 z-10 -rotate-3",
                "absolute left-1/2 -translate-x-1/2 bottom-4 z-30",
                "absolute right-[5%] md:right-[8%] bottom-0 z-10 rotate-3",
              ];

              const cat = categoryMap[article.category];

              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className={`${positions[idx]} w-[280px] md:w-[340px] bg-background-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer`}
                >
                  <div className="relative h-40 md:h-48 overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      title={`${article.title} - 51黑料网`}
                      className="w-full h-full object-cover"
                      loading={idx === 0 ? "eager" : "lazy"}
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-white">
                        {cat.name}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 line-clamp-2">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                      <span>{article.publishedAt}</span>
                      <span className="flex items-center gap-1">
                        <span className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-fire-line text-accent-500"></i>
                        </span>
                        {(article.viewCount / 10000).toFixed(1)}万
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}